var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mermaid",domProps:{"innerHTML":_vm._s(_vm.fvalue)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }